/**
 * ページタイトル設定
 * @param pathTitle
 * @returns {string}
 */
 export const setTitle = pathTitle => {
    const siteTitle = '';
    const pageTitle = !pathTitle ? siteTitle : pathTitle;
    return (window.document.title = pageTitle);
};

/**
 * Description設定
 * @param pathMeta
 */
export const setDescription = pathMeta => {
    const defaultDescription = 'This is initial description.';
    const description = pathMeta ? pathMeta : defaultDescription;
    document
        .querySelector("meta[name='description']")
        .setAttribute('content', description);
};

/**
 * 構造化データ（JSON-LD）設定
 * ページ遷移ごとに <head> 内の管理用 script タグを差し替える。
 * jsonld が無いページでは既存のタグを削除する。
 * @param jsonld ルートの meta.jsonld（オブジェクト）
 */
export const setJsonLd = jsonld => {
    const id = 'route-jsonld';
    let script = document.getElementById(id);

    if (!jsonld) {
        if (script) {
            script.remove();
        }
        return;
    }

    if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = id;
        document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(jsonld);
};


export const globalMixins = {
    methods: {
        setTitle,
        setDescription,
        setJsonLd,
    },
};